function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { i18n } from 'invision-core';
import LocaleKeys from '../../../locales/keys';
import { NOTIFICATION_TIME_LENGTH, REGEXES } from '../../../customercare.constants';
import { submitResendGiftCardNotification } from '../../../reducers/actions/giftcard.result.actions';
import { CurrentGiftCardSelector, GiftCardNotificationErrorSelector, IsResendingGiftCardNotificationSelector } from '../../../reducers/selectors/giftcard.result.selectors';
var ResendDialogComponent = /*#__PURE__*/function () {
  function ResendDialogComponent($ngRedux, uiNotificationService) {
    _classCallCheck(this, ResendDialogComponent);
    this.$ngRedux = $ngRedux;
    this.uiNotificationService = uiNotificationService;
    this.localeKeys = LocaleKeys;
    this.viewModel = {
      emailRegex: REGEXES.EMAIL,
      errorMessages: [],
      resendGiftCardModel: {
        Id: -1,
        RecipientEmail: '',
        RecipientName: '',
        SenderName: '',
        notifySender: true,
        message: ''
      }
    };
  }
  return _createClass(ResendDialogComponent, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var controllerActions = {
        submitResendGiftCardNotification: submitResendGiftCardNotification
      };
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          giftCard: CurrentGiftCardSelector(store),
          resendGiftCardnotificationError: GiftCardNotificationErrorSelector(store),
          isResendingGiftCardNotification: IsResendingGiftCardNotificationSelector(store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changes) {
      if (changes.giftCard) {
        this.viewModel.resendGiftCardModel = Object.assign(this.viewModel.resendGiftCardModel, changes.giftCard.currentValue);
      }
    }
  }, {
    key: "handleClose",
    value: function handleClose(hasResent) {
      this.onClose()(hasResent);
    }
  }, {
    key: "onSubmitForm",
    value: function onSubmitForm() {
      var _this2 = this;
      if (!this.giftCardResendForm.$invalid) {
        var promise = this.actions.submitResendGiftCardNotification(this.viewModel.resendGiftCardModel);
        promise.then(function () {
          _this2.uiNotificationService.success(i18n.translate(_this2.localeKeys.GIFT_CARD_DETAILS.SUCCESS), null, {
            timeOut: NOTIFICATION_TIME_LENGTH
          });
        }).catch(function (error) {
          _this2.uiNotificationService.error(error.translatedMessage, null, {
            timeOut: NOTIFICATION_TIME_LENGTH
          });
        }).then(function () {
          _this2.handleClose(true);
        });
      }
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }]);
}();
export default {
  template: require('./resend.gift.card.dialog.html'),
  controller: ResendDialogComponent,
  bindings: {
    config: '<',
    onClose: '&',
    onSuccess: '&',
    giftCard: '<'
  }
};